<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" mx-auto>
        <v-layout row wrap v-if="lAction === 'view'">
          <v-flex xs12>
            <v-flex class="text-right">
              <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
            </v-flex>
            <v-card-title class="px-0 py-2">
              <v-text-field
              class="pt-0"
              append-icon="mdi-account-search"
              :placeholder="$vuetify.breakpoint.smAndUp?'Search by Name, Manager, etc.':'Search'"
              hide-details
              v-model="search"
              outlined
              clearable
              ></v-text-field>
            </v-card-title>
          </v-flex>
          <v-flex xs12 sm8>
            <v-card>
              <v-card-title class="pa-2 primary--text grey lighten-4">
                Maintenance Projects ({{projectList.length}})
              </v-card-title>
              <v-card-text class="pa-0">
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?projectSm:project"
                :items="projectList"
                hide-default-footer
                disable-pagination
                :search="search"
                multi-sort
                :mobile-breakpoint="0">
                <template slot="item" slot-scope="props">
                  <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status ==='Closed' ? 'grey--text' : ''">
                    <td>{{ props.item.proj_name }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.emp_name_with_id || '-' }}</td>
                    <td>{{ props.item.proj_status }}</td>
                    <td>{{ props.item.agreed_head_count }}</td>
                    <td>{{ props.item.deployed }}</td>
                    <td>{{ props.item.billable_staff }}</td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm4>
          <v-card>
            <v-card-title class="pa-2 primary--text grey lighten-4">
              Turkey Projects ({{turnkeyList.length}})
            </v-card-title>
            <v-card-text class="ma-0 pa-0">
              <v-data-table
              :headers="$vuetify.breakpoint.smAndUp?turnkeySm:turnkey"
              :items="turnkeyList"
              hide-default-footer
              disable-pagination
              :search="search"
              multi-sort
              :mobile-breakpoint="0">
              <template slot="item" slot-scope="props">
                <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                  <td>{{ props.item.proj_name }}</td>
                  <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.emp_name_with_id || '-' }}</td>
                  <td>{{ props.item.proj_status }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-layout>

  <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
    <v-layout row wrap>
      <v-flex xs12 md9 mx-auto>
        <div class="title mb-2">
          <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
          <span class="pl-2 primary--text">{{lProject.proj_name}}</span>
        </div>
        <v-form ref="pForm" @submit.prevent="saveProjectChanges(lAction)">
          <v-expansion-panels :value="lAction === 'create' ? 0 : 1">
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title class="pa-0">
                  {{ handy.startWithUpper(lAction) + ' Project' }}
                </v-card-title>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text class="px-0 py-3">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                      v-model="lProject.proj_type"
                      label="Project Type"
                      :items="['Maintenance', 'Turnkey']"
                      hide-details
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-combobox
                      v-model="lProject.comm_pair"
                      label="Community"
                      :items="commList"
                      item-text="comm_name"
                      item-value="comm_id"
                      :rules="[rules.required]"
                      hide-details
                      @input="loadRoles(lProject.comm_pair)"
                      :disabled="lAction === 'update'"
                      ></v-combobox>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                      v-model="lProject.proj_name"
                      label="Project Name"
                      :rules="[rules.required]"
                      hide-details
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-dialog ref="dlgstartDt"
                      persistent v-model="dlgstartDt"
                      max-width="290px"
                      class="pt-0"
                      :return-value.sync="lProject.proj_start">
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        label="Contract Start Date"
                        v-model="lProject.proj_start" append-icon="mdi-calendar-today"
                        readonly
                        v-on="on"
                        hide-details
                        ></v-text-field>
                      </template>
                      <v-date-picker
                      v-model="lProject.proj_start"
                      scrollable
                      >
                      <div class="flex-grow-1"></div>
                      <v-btn text @click="dlgstartDt = false">Cancel</v-btn>
                      <v-btn text color="accent" @click="$refs.dlgstartDt.save(lProject.proj_start)">OK</v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs6>
                  <v-dialog ref="dlgendDt"
                  persistent v-model="dlgendDt"
                  max-width="290px"
                  class="pt-0"
                  :return-value.sync="lProject.proj_end">
                  <template v-slot:activator="{ on }">
                    <v-text-field
                    slot="activator" label="Contract End Date"
                    v-model="lProject.proj_end" append-icon="mdi-calendar-today"
                    readonly
                    hide-details
                    v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                  :min="lProject.proj_start"
                  v-model="lProject.proj_end"
                  scrollable
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn text @click="dlgendDt = false">Cancel</v-btn>
                  <v-btn text color="accent" @click="$refs.dlgendDt.save(lProject.proj_end)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex xs6>
              <v-combobox
              v-model="lProject.proj_manager_pair"
              label="Account/Ops Manager"
              :items="empList"
              item-value="emp_id"
              item-text="emp_name_with_id"
              :rules="[rules.required]"
              hide-details
              ></v-combobox>
            </v-flex>
            <v-flex xs6>
              <v-combobox
              v-model="lProject.field_office_pair"
              label="Field Officer"
              :items="fieldOfficeList"
              item-value="vendor_emp_id"
              item-text="emp_with_id"
              :rules="[rules.required]"
              hide-details
              ></v-combobox>
            </v-flex>
            <v-flex xs6>
              <v-select
              v-model="lProject.proj_status"
              label="Status"
              :items="['Active', 'Closed']"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-dialog ref="actClosedDt"
              persistent v-model="actClosedDt"
              max-width="290px"
              class="pt-0"
              :return-value.sync="lProject.act_closed_date">
              <template v-slot:activator="{ on }">
                <v-text-field
                :class="lProject.proj_status === 'Active' ? lProject.act_closed_date = null : lProject.act_closed_date"
                slot="activator" label="Actual Closed Date"
                v-model="lProject.act_closed_date" append-icon="mdi-calendar-today"
                readonly
                :rules="[rules.required]"
                hide-details
                v-on="on"
                :disabled="lProject.proj_status === 'Active'"
                ></v-text-field>
              </template>
              <v-date-picker
              v-model="lProject.act_closed_date"
              scrollable
              >
              <div class="flex-grow-1"></div>
              <v-btn text @click="actClosedDt = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.actClosedDt.save(lProject.act_closed_date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 class="pt-2">
          <v-textarea
          v-model="lProject.closed_reason"
          label="Reason For Closing"
          rows="1"
          hide-details
          maxlength="3000"
          :rules="[rules.required]"
          outlined
          :disabled="lProject.proj_status === 'Active'"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 class="pt-5">
          <v-select
          v-model="lProject.user_proj_list"
          label="Users Exposed To Clients (Point Of Contact)"
          :items="userList"
          item-value="user_id"
          item-text="user_name_with_role"
          outlined
          small-chips
          multiple
          clearable
          hint="There users will be visible in client's Smartility application as backoffice representatives"
          persistent-hint
          ></v-select>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions>
      <v-btn v-if="lAction === 'update'" @click="deleteProject(lProject)">delete</v-btn>
      <v-spacer></v-spacer>
      <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
    </v-card-actions>
  </v-expansion-panel-content>
</v-expansion-panel>

<v-expansion-panel v-if="this.lProject.proj_id">
  <v-expansion-panel-header>
    <v-card-title class="pa-0">
      Staff Deployment
    </v-card-title>
  </v-expansion-panel-header>
  <v-expansion-panel-content>
    <v-card-text class="pa-0">
      <v-layout row wrap>
        <v-flex xs12 class="text-center">
          <v-btn class="mr-2" small @click="prepareCreateRoles">Deploy New Role</v-btn>
          <v-chip :class="(isUndepShown ? 'info dark' : '') + ($vuetify.breakpoint.smAndUp ? '' : ' mt-2')" @click="showUndeployed()">Show Undeployed Staffs</v-chip>
        </v-flex>
        <v-flex xs12>
          <div class="pb-3" v-for="(roleId, n) in projRolesList" :key="n">
            <v-card>
              <v-card-title :class="lProject.roleStaff.find(rec => rec.staff_role_id === roleId).agreed_head_count != lProject.roleStaff.find(rec => rec.staff_role_id === roleId).is_billable ? 'pa-2 title primary--text error lighten-4' : lProject.roleStaff.find(rec => rec.staff_role_id === roleId).agreed_head_count != lProject.roleStaff.find(rec => rec.staff_role_id === roleId).employee_list.length ? 'pa-2 primary--text warning lighten-2' : 'pa-2 title primary--text grey lighten-4'">
                <v-layout row wrap>
                  <v-flex xs11>
                    <span>{{ roleList.find(rec => rec.staff_role_id === roleId).staff_role }}</span>
                    <span class="caption"> (</span>
                    <span class="caption"><a style="text-decoration: underline;" @click="prepareUpateHeadCounts(roleId, lProject.roleStaff.find(rec => rec.staff_role_id === roleId))">{{'Agreed: ' + lProject.roleStaff.find(rec => rec.staff_role_id === roleId).agreed_head_count }}</a></span>
                    <span class="caption">{{', Deployed: ' + lProject.roleStaff.find(rec => rec.staff_role_id === roleId).employee_list.length + ', Billable: ' + lProject.roleStaff.find(rec => rec.staff_role_id === roleId).is_billable + ')' }}</span>
                  </v-flex>
                  <v-flex xs1 class="pa-0 text-right">
                    <v-spacer></v-spacer>
                    <v-btn icon v-if="lProject.roleStaff.find(rec => rec.staff_role_id === roleId).employee_list.length === 0" @click="deleteRole(roleId)"><v-icon small>mdi-delete</v-icon></v-btn>
                    <v-btn icon @click="prepareCreateEmployee(roleId)"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="ma-0 pa-0">
                <v-data-table
                :headers="$vuetify.breakpoint.smAndUp?roleHd:roleHdSm"
                :items="lProject.roleStaff.find(rec => rec.staff_role_id === roleId).employee_list"
                hide-default-footer
                disable-pagination
                :mobile-breakpoint="0"
                >
                <template slot="item" slot-scope="props">
                  <tr @click="prepareUpdateEmployee(props.item, roleId)" :class="props.item.undeployed_on ? 'grey--text' : ''">
                    <td>{{ $vuetify.breakpoint.smAndUp?props.item.emp_name_with_id:props.item.emp_name }}</td>
                    <td>{{ props.item.deployed_on?handy.formatDate(props.item.deployed_on):'-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.undeployed_on?handy.formatDate(props.item.undeployed_on):'-' }}</td>
                    <td v-if="$vuetify.breakpoint.smAndUp"><v-icon :color="props.item.is_billable ? 'green' : 'red'">{{ props.item.is_billable ? 'mdi-check' : 'mdi-close' }}</v-icon></td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-flex>
    </v-layout>
  </v-card-text>
</v-expansion-panel-content>
</v-expansion-panel>
</v-expansion-panels>
</v-form>
</v-flex>
</v-layout>
</v-container>

<v-dialog v-model="showRole" persistent max-width="500px">
  <v-form ref="servForm">
    <v-card flat>
      <v-flex xs12>
        <v-card-title>
          <div v-if="lRoles.agreed === true">
            Agreed headcount as per contract
          </div>
          <div v-else>
            Choose a Role
          </div>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 v-if="lRoles.agreed != true">
            <v-select
            v-model="lRoles.staff_role_id"
            label="Roles"
            :items="roleList"
            item-text="staff_role"
            item-value="staff_role_id"
            :rules="[rules.required]"
            hide-details
            ></v-select>
          </v-flex>
          <v-flex xs12 class="pt-2">
            <v-text-field
            label="Agreed headcount as per contract"
            v-model="lRoles.agreed_head_count"
            type="number"
            hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 class="px-3">
            <v-layout row wrap>
              <v-flex xs12 sm5>
                <v-checkbox
                v-model="lRoles.is_part_time"
                label="Is part-time service?"
                hide-details
                @click="$forceUpdate()"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 sm7 class="pt-1" v-if="lRoles.is_part_time === true">
                <v-text-field
                label="Agreed number of days in a month per person"
                v-model="lRoles.agreed_days"
                type="number"
                hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-flex>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click.stop="showRole = false">Cancel</v-btn>
        <v-btn text color="accent" v-if="lRoles.agreed != true" :disabled="beingSaved" @click="saveRoles()">Save</v-btn>
        <v-btn text color="accent" v-else :disabled="beingSaved" @click="saveAgreedHeadCounts()">Save</v-btn>
      </v-card-actions>
    </v-flex>
  </v-card>
</v-form>
</v-dialog>

<v-dialog v-model="showEmployee" persistent max-width="600px">
  <v-form ref="empForm">
    <v-card flat v-if="roleList.find(rec => rec.staff_role_id === lEmployeeRole)">
      <v-flex xs12>
        <v-card-title>
          <div>
            {{ handy.startWithUpper(lPAction) + ' ' + roleList.find(rec => rec.staff_role_id === lEmployeeRole).staff_role }}
          </div>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap class="px-3">
            <v-flex xs12 sm9>
              <v-combobox
              v-model="lEmployee.emp_pair"
              label="Employee"
              :items="lEmployee.showAll ? empList : empList.filter(rec => rec.emp_desig.toLowerCase().includes(roleList.find(rec => rec.staff_role_id === lEmployeeRole).staff_role.toLowerCase()))"
              item-text="emp_name_with_id"
              item-value="vendor_emp_id"
              :rules="[rules.required]"
              :disabled="lPAction === 'update'"
              return-object
              hint="Could not find the employee? Enable show all and try again"
              persistent-hint
              clearable
              @change="lEmployee.emp_pair ? loadListOfActiveProjects(lEmployee.emp_pair.vendor_emp_id) : listOfProject=[]"
              ></v-combobox>
            </v-flex>
            <v-flex xs12 sm3>
              <v-switch
              v-model="lEmployee.showAll"
              label="Show all"
              :disabled="lPAction === 'update'"
              @click="loadEmployee()"
              ></v-switch>
            </v-flex>
            <v-flex xs12 md6 class="pa-1">
              <v-dialog ref="dlgdeployedDt"
              persistent v-model="dlgdeployedDt"
              max-width="290px"
              class="pt-0"
              :return-value.sync="lEmployee.deployed_on">
              <template v-slot:activator="{ on }">
                <v-text-field
                slot="activator" label="Deployed Date"
                v-model="lEmployee.deployed_on" append-icon="mdi-calendar-today"
                readonly
                v-on="on"
                hide-details
                :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
              v-model="lEmployee.deployed_on"
              scrollable
              >
              <div class="flex-grow-1"></div>
              <v-btn text @click="dlgdeployedDt = false">Cancel</v-btn>
              <v-btn text color="accent" @click="$refs.dlgdeployedDt.save(lEmployee.deployed_on)">OK</v-btn>
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 md6 class="pa-1">
          <v-dialog ref="dlgUndeployedDt"
          persistent v-model="dlgUndeployedDt"
          max-width="290px"
          class="pt-0"
          :return-value.sync="lEmployee.undeployed_on">
          <template v-slot:activator="{ on }">
            <v-text-field
            slot="activator" label="Undeployed Date"
            v-model="lEmployee.undeployed_on" append-icon="mdi-calendar-today"
            readonly
            hide-details
            v-on="on"
            clearable
            ></v-text-field>
          </template>
          <v-date-picker
          :min="lEmployee.deployed_on"
          v-model="lEmployee.undeployed_on"
          scrollable
          >
          <div class="flex-grow-1"></div>
          <v-btn text @click="dlgUndeployedDt = false">Cancel</v-btn>
          <v-btn text color="accent" @click="$refs.dlgUndeployedDt.save(lEmployee.undeployed_on)">OK</v-btn>
        </v-date-picker>
      </v-dialog>
    </v-flex>
    <v-flex xs12 sm6 v-if="lPAction === 'update'">
      <v-select
      v-model="lEmployee.staff_role_id"
      label="Staff role"
      :items="roleList"
      item-value="staff_role_id"
      item-text="staff_role"
      hide-details
      ></v-select>
    </v-flex>
    <v-flex xs12 sm6 class="px-2">
      <v-checkbox
      v-model="lEmployee.is_billable"
      label="Is Billable?"
      hide-details
      ></v-checkbox>
    </v-flex>
    <v-flex xs12 class="pt-4 mt-3" v-if="lEmployee.emp_pair && listOfProject.length>0 && lPAction !== 'update'">
      <v-alert outlined color="accent" class="pa-2">
        <span>WARNING: {{lEmployee.emp_pair.emp_name_with_id}} is already deployed in below projects </span><br/></br/>
        <v-flex v-for="(projId, n) in listOfProject" :key="n">
          <span>{{n+1 + '.' + " " + listOfProject.find(rec => rec.proj_id === projId.proj_id).proj_name}}</span>
        </v-flex>
      </v-alert>
    </v-flex>
  </v-layout>
</v-card-text>
<v-card-actions>
  <v-btn text v-if="lPAction === 'update'" @click="deleteEmployee(lEmployee)">delete</v-btn>
  <v-spacer></v-spacer>
  <v-btn text @click.stop="showEmployee = false">Cancel</v-btn>
  <v-btn text color="accent" :disabled="beingSaved" @click="saveEmployee()">Save</v-btn>
</v-card-actions>
</v-flex>
</v-card>
</v-form>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</v-col>
</v-row>
</v-container>
</template>

<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  data () {
    return {
      lAction: '',
      lPAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      handy: handy,
      rules: handy.rules,
      beingSaved: false,
      projectSm: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Project Manager', value: 'emp_name_with_id' },
        { text: 'Status', value: 'proj_status' },
        { text: 'Agreed', value: 'agreed_head_count' },
        { text: 'Deployed', value: 'deployed' },
        { text: 'Billable', value: 'billable_staff' }
      ],
      project: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Status', value: 'proj_status' }
      ],
      turnkeySm: [
        { text: 'Proj Name', value: 'proj_name' },
        { text: 'Proj Manager', value: 'emp_name_with_id' },
        { text: 'Status', value: 'proj_status' }
      ],
      turnkey: [
        { text: 'Project Name', value: 'proj_name' },
        { text: 'Status', value: 'proj_status' }
      ],
      projectList: [],
      lProject: [],
      dlgstartDt: false,
      dlgendDt: false,
      turnkeyList: [],
      roleHd: [
        { text: 'Employee Name', value: 'emp_name_with_id' },
        { text: 'Deployed On', value: 'deployed_on' },
        { text: 'Undeployed On', value: 'undeployed_on' },
        { text: 'Billable?', value: 'is_billable' }
      ],
      roleHdSm: [
        { text: 'Employee Name', value: 'emp_name_with_id' },
        { text: 'Deployed On', value: 'deployed_on' }
      ],
      staffList: [],
      isUndepShown: false,
      projRolesList: [],
      showRole: false,
      lRoles: {},
      roleList: [],
      commList: [],
      empList: [],
      showEmployee: false,
      lEmployee: {},
      dlgdeployedDt: false,
      dlgUndeployedDt: false,
      lEmployeeRole: '',
      userList: [],
      listOfProject: [],
      newRoleAdded: false,
      isClosedProject: false,
      fieldOfficeList: [],
      actClosedDt: false
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  created () {
    this.loadMaintenanceProject()
    this.loadTurnkeyProject()
  },
  mounted () {
    this.lAction = 'view'
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadMaintenanceProject () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.axios.get(config.API_URL + '/getMaintProjByVendorId/', qry)
      .then(response => {
        this.projectList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadTurnkeyProject () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.axios.get(config.API_URL + '/getTurnkeyProjByVendorId/', qry)
      .then(response => {
        this.turnkeyList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreate () {
      this.staffList = []
      this.projRolesList = []
      this.lProject = {
        vendor_id: config.VENDOR_ID,
        org_vendor_id: config.VENDOR_ID,
        proj_type: 'Maintenance',
        proj_name: '',
        comm_pair: '',
        proj_start: this.today,
        proj_end: null,
        proj_manager_pair: '',
        field_office_pair: '',
        proj_status: 'Active',
        roleStaff: []
      }
      this.lAction = 'create'
      this.loadCommunity()
      this.loadEmployee()
      this.loadListOfFieldOfficer()
      this.loadUsers()
    },
    prepareUpdate (curProject) {
      this.lProject = Object.assign({}, curProject) // keep the original object safely before changes
      this.lProject.proj_start = handy.formatDBDate(curProject.proj_start)
      this.lProject.proj_end = this.lProject.proj_end ? handy.formatDBDate(this.lProject.proj_end) : null
      this.lProject.act_closed_date = this.lProject.act_closed_date ? handy.formatDBDate(this.lProject.act_closed_date) : null
      this.lProject.proj_manager_pair = this.lProject.proj_manager_pair || ({ emp_id: this.lProject.proj_manager, emp_name_with_id: this.lProject.emp_name_with_id })
      this.lProject.comm_pair = this.lProject.comm_pair || ({ comm_id: this.lProject.comm_id, comm_name: this.lProject.comm_name })
      this.lProject.user_proj_list = this.lProject.user_proj_list || (this.lProject.proj_poc_list ? this.lProject.proj_poc_list.split(',').map(Number) : [])
      if (this.lProject.field_officer_name) {
        this.lProject.field_office_pair = { emp_id: this.lProject.field_officer, emp_with_id: this.lProject.field_officer_name + ' (' + this.lProject.field_officer + ')' }
      }
      this.loadRoles(this.lProject.comm_pair)
      this.loadStaffList(this.lProject.proj_id)
      this.loadCommunity()
      this.loadEmployee()
      this.loadUsers()
      this.loadListOfFieldOfficer()
      this.lAction = 'update'
    },
    loadStaffList (curProjId) {
      var qry = {
        params: {
          proj_id: curProjId,
          is_undep_shown: this.isUndepShown
        }
      }
      this.lProject.roleStaff = []
      this.projRolesList = []
      this.axios.get(config.API_URL + '/getStaffListbyProjectId/', qry)
      .then(response => {
        this.staffList = response.data
        this.staffList.forEach(rec => {
          rec.deployed_on = handy.formatDBDate(rec.deployed_on)
        })
        this.projRolesList = handy.unique(this.staffList.map(rec => rec.staff_role_id))
        this.projRolesList.forEach(rec => {
          this.lProject.roleStaff.push({
            staff_role_id: rec,
            is_part_time: this.staffList.find(staff => staff.staff_role_id === rec).is_part_time,
            agreed_days: this.staffList.find(staff => staff.staff_role_id === rec).agreed_days,
            agreed_head_count: this.staffList.find(staff => staff.staff_role_id === rec).agreed_head_count,
            is_billable: this.staffList.filter(staff => staff.staff_role_id === rec && staff.is_billable === 1).length,
            employee_list: this.staffList.filter(staff => staff.staff_role_id === rec)
          })
        })
      })
      .catch(err => {
        this.msg(err)
      })
    },
    showUndeployed () {
      this.isUndepShown = !this.isUndepShown
      this.loadStaffList(this.lProject.proj_id)
    },
    loadRoles (curComm) {
      // populate default project name
      if (this.lAction === 'create') {
        this.lProject.proj_name = curComm.comm_name
      }
      // load roles of this community
      var qry = {
        params: {
          comm_id: curComm.comm_id
        }
      }
      this.axios.get(config.API_URL + '/getStaffRolesByCommId/', qry)
      .then(response => {
        this.roleList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getProjectCommunity/', qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadEmployee () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getEmployeeByVendorId/', qry)
      .then(response => {
        this.empList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    prepareCreateRoles () {
      this.lRoles = {
        staff_role_id: '',
        staff_role: '',
        agreed_head_count: null,
        is_part_time: false
      }
      this.showRole = true
    },
    saveRoles () {
      if (this.$refs.servForm.validate()) {
        if (this.lRoles.is_part_time && !this.lRoles.agreed_days) {
          this.msg('Please enter agreed number of days in a month to reflect it in attendance', 0)
          return
        }
        if (!this.lRoles.agreed_head_count) {
          this.msg('Please enter the Agreed Head counts to reflect the role in this project', 0)
          return
        }
        this.beingSaved = true
        this.newRoleAdded = true
        this.projRolesList.push(this.lRoles.staff_role_id)
        this.lProject.roleStaff.push({
          staff_role_id: this.lRoles.staff_role_id,
          agreed_head_count: this.lRoles.agreed_head_count,
          is_part_time: this.lRoles.is_part_time,
          agreed_days: this.lRoles.agreed_days,
          is_billable: 0,
          employee_list: []
        })
        this.beingSaved = false
        this.showRole = false
        this.$forceUpdate()
      }
    },
    prepareUpateHeadCounts (curRoleId, curRec) {
      this.lRoles.agreed_head_count = curRec.agreed_head_count,
      this.lRoles.staff_role_id = curRoleId,
      this.lRoles.agreed_days = curRec.agreed_days
      this.lRoles.is_part_time = curRec.is_part_time === 1 ? true : false
      this.lRoles.agreed = true
      this.showRole = true
    },
    saveAgreedHeadCounts () {
      if (!this.lRoles.agreed_head_count) {
        this.msg('Agreed Head counts cannot be null. Please enter the Agreed Head counts', 0)
        return
      }
      this.axios.post(config.API_URL + '/projectAgreedHeadCount/update', this.lRoles)
      .then(response => {
        var idx = this.lProject.roleStaff.findIndex(rec => rec.staff_role_id === this.lRoles.staff_role_id)
        if (idx > -1) {
          this.lProject.roleStaff[idx].agreed_head_count = this.lRoles.agreed_head_count
        }
        this.showRole = false
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    prepareCreateEmployee (curRoleId) {
      this.lEmployee = {
        comm_vendor_id: config.VENDOR_ID,
        vendor_emp_id: '',
        emp_pair: '',
        deployed_on: this.today,
        undeployed_on: null,
        staff_role_id: curRoleId,
        proj_id: this.lProject.proj_id,
        comm_id: this.lProject.comm_pair.comm_id,
        is_billable: true,
        agreed_head_count: this.lProject.roleStaff.find(rec => rec.staff_role_id === curRoleId).agreed_head_count,
        is_part_time: this.lProject.roleStaff.find(rec => rec.staff_role_id === curRoleId).is_part_time,
        agreed_days: this.lProject.roleStaff.find(rec => rec.staff_role_id === curRoleId).agreed_days
      }
      this.lEmployeeRole = curRoleId
      this.lPAction = 'add'
      this.showEmployee = true
    },
    saveEmployee () {
      if (this.$refs.empForm.validate()) {
        this.beingSaved = true
        this.lEmployee.vendor_emp_id = this.lEmployee.emp_pair.vendor_emp_id
        this.axios.post(config.API_URL + '/projectEmployee/' + this.lPAction, this.lEmployee)
        .then(response => {
          if (this.newRoleAdded) {
            this.axios.post(config.API_URL + '/projectAgreedHeadCount/create', this.lEmployee)
            .then(response => {
              this.loadStaffList(this.lProject.proj_id)
              this.showEmployee = false
              this.beingSaved = false
              this.newRoleAdded = false
            })
            .catch(err => {
              this.msg(err)
              this.beingSaved = false
            })
          } else {
            this.loadStaffList(this.lProject.proj_id)
            this.showEmployee = false
            this.beingSaved = false
            this.newRoleAdded = false
          }
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    deleteEmployee (curEmployee) {
      this.beingSaved = true
      this.axios.post(config.API_URL + '/projectEmployee/delete', this.lEmployee)
      .then(response => {
        this.loadStaffList(curEmployee.vendor_proj_id)
        this.beingSaved = false
        this.showEmployee = false
      })
      .catch(err => {
        this.msg(err)
        this.beingSaved = false
      })
    },
    prepareUpdateEmployee (curEmp, curRoleId) {
      this.lEmployee = Object.assign({}, curEmp)
      this.lEmployee.deployed_on = handy.formatDBDate(curEmp.deployed_on)
      this.lEmployee.undeployed_on = curEmp.undeployed_on ? handy.formatDBDate(curEmp.undeployed_on) : null
      this.lEmployee.emp_pair = { vendor_emp_id: this.lEmployee.vendor_emp_id, emp_name_with_id: this.lEmployee.emp_name_with_id }
      this.lEmployeeRole = curRoleId
      this.showEmployee = true
      this.lPAction = 'update'
    },
    saveProjectChanges (action) {
      // validate and save Changes
      if (this.$refs.pForm.validate()) {
        if (!this.lProject.comm_pair || !this.lProject.comm_pair.comm_id) {
          this.msg('Please choose valid community')
          return
        } else if (!this.lProject.proj_manager_pair || !this.lProject.proj_manager_pair.emp_id) {
          this.msg('Please choose valid account/ops manager')
          return
        } else if ((!this.lProject.field_office_pair || !this.lProject.field_office_pair.emp_id) && config.VENDOR_ID === 1) {
          this.msg('Please choose field officer')
          return
        }
        if (this.lProject.proj_status === 'Closed') {
          if (!this.lProject.act_closed_date) {
            this.msg('Please select actual closed date')
            return
          } else if (!this.lProject.closed_reason) {
            this.msg('Please give reason for closing')
            return
          }
        }
        this.beingSaved = true
        // pre-requsite
        this.lProject.comm_id = this.lProject.comm_pair.comm_id
        this.lProject.proj_manager = this.lProject.proj_manager_pair.emp_id
        if (config.VENDOR_ID === 1) {
          this.lProject.field_officer = this.lProject.field_office_pair.vendor_emp_id
        }
        this.axios.post(config.API_URL + '/project/' + action, this.lProject)
        .then(response => {
          this.lProject.proj_id = response.data
          if (action === 'update') {
            this.lProject.field_officer = this.lProject.vendor_emp_id
            this.lProject.field_officer_name = this.lProject.emp_name
            this.lProject.field_officer_pair = { emp_id: this.lProject.emp_name, emp_with_id: this.lProject.emp_name + ' (' + this.lProject.vendor_emp_id + ')' }
            this.lProject.emp_name_with_id = this.lProject.proj_manager_pair.emp_name + ' (' + this.lProject.proj_manager_pair.emp_id + ')'
            if (this.lProject.proj_type === 'Maintenance') {
              var idx = this.projectList.findIndex(obj => obj.proj_id === this.lProject.proj_id)
              Object.assign(this.projectList[idx], this.lProject)
            } else {
              var idx = this.turnkeyList.findIndex(obj => obj.proj_id === this.lProject.proj_id)
              Object.assign(this.turnkeyList[idx], this.lProject)
            }
            this.msg('Saved successfully', 1)
            this.loadMaintenanceProject()
            this.loadTurnkeyProject()
          } else {
            this.lProject.emp_name_with_id = this.lProject.proj_manager_pair.emp_name + ' (' + this.lProject.proj_manager_pair.emp_id + ')'
            if (this.lProject.proj_type === 'Maintenance') {
              this.projectList.push(this.lProject)
            } else {
              this.turnkeyList.push(this.lProject)
            }
          }
          this.lAction = 'update'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err)
          this.beingSaved = false
        })
      }
    },
    deleteRole (curRoleId) {
      this.beingSaved = true
      var cidx = this.lProject.roleStaff.findIndex(rec => rec.staff_role_id === curRoleId)
      this.lProject.roleStaff.splice(cidx, 1)
      this.projRolesList.splice(this.projRolesList.findIndex(rec => rec.staff_role_id === curRoleId), 1)
      this.beingSaved = false
      this.$forceUpdate()
    },
    deleteProject (curProject) {
      if (!confirm('Sure, you want to delete the project with project name "' + curProject.proj_name + '"?')) {
        return
      }
      // up in db
      this.beingSaved = true
      if (curProject.roleStaff.filter(rec => rec.employee_list.length > 0).length) {
        this.msg('This project cannot be deleted as staffs are associcated with it', 0)
        this.beingSaved = false
      } else {
        this.axios.post(config.API_URL + '/project/delete', curProject)
        .then(response => {
          // refresh stats
          if (this.lProject.proj_type === 'Maintenance') {
            var idx = this.projectList.findIndex(obj => obj.proj_id === this.lProject.proj_id)
            this.projectList.splice(idx, 1)
          } else {
            var idx = this.turnkeyList.findIndex(obj => obj.proj_id === this.lProject.proj_id)
            this.turnkeyList.splice(idx, 1)
          }
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch(err => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    cancelChanges () {
      // refresh the Project list
      this.loadMaintenanceProject()
      this.loadTurnkeyProject()
      this.loadCommunity()
      this.loadEmployee()
      this.lAction = 'view'
    },
    loadUsers () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUsersByVendor/', qry)
      .then(response => {
        this.userList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.userList = []
      })
    },
    loadListOfActiveProjects (curVendorEmpId) {
      var qry = {
        params: {
          vendor_emp_id: curVendorEmpId
        }
      }
      this.axios.get(config.API_URL + '/getListOfProjects/', qry)
      .then(response => {
        this.listOfProject = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.listOfProject = []
      })
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadMaintenanceProject()
      this.loadTurnkeyProject()
    },
    loadListOfFieldOfficer () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getFieldOfficerByVendorId/', qry)
      .then(response => {
        this.fieldOfficeList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
        this.fieldOfficeList = []
      })
    }
  }
}
</script>
